import { Card, Col, Layout, Row, Spin } from 'antd';
import { BaseHeader, BlankLayout, Status } from 'app/modules/ui';
import React, { useContext } from 'react';
import classes from './Report.module.scss';
import { InspectionContext } from '../../contexts/inspection';
import { HeaderDescriptionDefs } from './constants';
import get from 'lodash/get';
import { HEADER_LEFT_COL, HEADER_RIGHT_COL } from './config';
import ReportContent from './content/ReportContent';
import { PRESETS_INSPECTION_RESULT } from '../../constants';
import { useNavigate } from 'react-router';

export const InspectionReport = () => {
  const navigate = useNavigate();
  const { inspection, progress, loading } = useContext(InspectionContext);

  const overallReportResult = React.useMemo(() => {
    if (loading) return null;
    if (progress) {
      const [label, color] = PRESETS_INSPECTION_RESULT.get(
        progress.overallResult
      );
      return {
        text: label,
        color: color
      };
    }
    return {
      text: 'N/A',
      color: 'default'
    };
  }, [progress, loading]);

  return (
    <Layout className={classes.report}>
      <BaseHeader
        title="Inspection Job Detail"
        backButton
        onBack={() => {
          navigate(`/dashboard/inspection/job/${inspection?.id}`);
        }}
        leftColProps={HEADER_LEFT_COL}
        rightColProps={HEADER_RIGHT_COL}
        right={
          <Row
            className={classes['report__header-description']}
            justify="end"
            gutter={[16, 16]}
          >
            {HeaderDescriptionDefs.map((def) => {
              return (
                <Col
                  key={def.dataIndex}
                  className={classes['report__header-description__item']}
                >
                  <span
                    className={
                      classes['report__header-description__item__label']
                    }
                  >
                    {def.label}
                  </span>
                  <span
                    className={
                      classes['report__header-description__item__content']
                    }
                  >
                    {typeof def.render === 'function'
                      ? def.render(get(inspection, def.dataIndex), inspection, {
                          progress
                        })
                      : get(inspection, def.dataIndex)}
                  </span>
                </Col>
              );
            })}
          </Row>
        }
      />
      <Layout className={classes['report__content']}>
        <Layout.Sider width={320} className={classes['report__sider']}>
          <Card className={classes['report__card-status']}>
            <div className={classes['report__card-status__content']}>
              <Card.Meta
                className={classes['report__card-status__meta']}
                title="Internal Inspection Report"
              ></Card.Meta>
              <span>
                <Status
                  type="text"
                  value={overallReportResult?.text}
                  color={overallReportResult?.color as string}
                />
              </span>
            </div>
          </Card>
        </Layout.Sider>
        <BlankLayout className={classes['report__report-content']} shadow>
          <ReportContent overallReportResult={overallReportResult as any} />
        </BlankLayout>
      </Layout>
    </Layout>
  );
};
